module.exports = "../../../../platform/assets/pageMainIcon/icon-tongyong-2-blue.svg";